import styled, { css } from 'styled-components';

export const Content = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    cursor: pointer;
  }
`;

export const FieldsContainer = styled.div`
  padding-top: 26px;
`;

export const OpenedInputDescription = styled.span`
  font-size: 12px;
  color: #425AF4;
`;

export const ButtonsContainer = styled.div`
  padding-top: 26px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex: 1;

  button + button {
    margin-left: 16px;
  }
`;
